<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <div class="card-header"><div class="card-title">{{ cardTitle }}</div></div>
    <div class="card-body">
      <div class="row mb-3">
        <div class="col-12 col-sm-6">
          <label class="form-label fw-bold">اسم الباقة - عربي:</label>
          <p>{{ dataRow.title }}</p>
        </div>
        <div class="col-12 col-sm-6">
          <label class="form-label fw-bold">اسم الباقة - انجليزي:</label>
          <p>{{ dataRow.titleEn }}</p>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-12 col-sm-3">
          <label class="form-label fw-bold">السعر:</label>
          <p>{{ dataRow.price }} ر.س</p>
        </div>
        <div class="col-12 col-sm-3">
          <label class="form-label fw-bold">المدة:</label>
          <p>{{ dataRow.durationMonths }} شهر</p>
        </div>
        <div class="col-12 col-sm-3">
          <label class="form-label fw-bold">عدد مرات الاستخدام:</label>
          <p>{{ dataRow.visitsCount }}</p>
        </div>
        <div class="col-12 col-sm-3">
          <label class="form-label fw-bold">نسبة الخصم:</label>
          <p>{{ dataRow.discountPercentage }}%</p>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-12 col-sm-6">
          <label class="form-label fw-bold">الوصف:</label>
          <p>{{ dataRow.description }}</p>
        </div>
        <div class="col-12 col-sm-6">
          <label class="form-label fw-bold">الشروط والأحكام:</label>
          <p style="white-space: pre-line;">{{ dataRow.terms }}</p>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-12 col-sm-6">
          <label class="form-label fw-bold">الخدمات المشمولة:</label>
          <ul>
            <li v-for="item in includedServices" :key="`v-inc-${item.id}`">
              {{ item.MaintenanceIssue? item.MaintenanceIssue.name : item.issueId }}
            </li>
            <li v-if="!includedServices.length" class="text-muted">لا يوجد</li>
          </ul>
        </div>
        <div class="col-12 col-sm-6">
          <label class="form-label fw-bold">الخدمات التي عليها خصم ({{ dataRow.discountPercentage }}%):</label>
          <ul>
            <li v-for="item in discountServices" :key="`v-dis-${item.id}`">
              {{ item.MaintenanceIssue? item.MaintenanceIssue.name : item.issueId }}
            </li>
            <li v-if="!discountServices.length" class="text-muted">لا يوجد</li>
          </ul>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-12 col-sm-6">
          <label class="form-label fw-bold">المميزات:</label>
          <ul>
            <li v-for="(item, indx) in (dataRow.features ?? [])" :key="`v-ft-${indx}`">{{ item }}</li>
            <li v-if="!(dataRow.features ?? []).length" class="text-muted">لا يوجد</li>
          </ul>
        </div>
        <div class="col-12 col-sm-6">
          <label class="form-label fw-bold">الحالة:</label>
          <p>{{ dataRow.isActive? 'نشط' : 'غير نشط' }}</p>
        </div>
      </div>

      <div v-if="dataRow.image" class="row">
        <div class="col-12">
          <img :src="MEDIA_URL+dataRow.image" class="img-thumbnail" style="max-width: 250px;" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'MaintenancePackagesView',
  props: {
    cardTitle: {
      type: String,
      default: 'عرض'
    },
    dataRow: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapGetters(['MEDIA_URL']),
    services(){
      return (this.dataRow && this.dataRow.MaintenancePackageIssues)? this.dataRow.MaintenancePackageIssues : [];
    },
    includedServices(){
      return this.services.filter(item => item.serviceType == 'included');
    },
    discountServices(){
      return this.services.filter(item => item.serviceType == 'discount');
    },
  },
}
</script>